import { render, staticRenderFns } from "./dingdListGK.vue?vue&type=template&id=1c941aa2&scoped=true"
import script from "./dingdListGK.vue?vue&type=script&lang=js"
export * from "./dingdListGK.vue?vue&type=script&lang=js"
import style0 from "./dingdListGK.vue?vue&type=style&index=0&id=1c941aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c941aa2",
  null
  
)

export default component.exports